import { configureStore } from "@reduxjs/toolkit";
import pageReducer from "./pageSlice";
import homePageReducer from "./HomePageSlice";
import brandsReducer from "./BrandsSlice";
import recipesReducer from "./RecipesSlice";
import footerReducer from "./FooterSlice";
import careerReducer from "./CareersSlice";
import contactReducer from "./contactSlice";
import jobFormReducer from "./JobFormSlice";

export const store = configureStore({
  reducer: {
    page: pageReducer,
    homePage: homePageReducer,
    brands: brandsReducer,
    recipes: recipesReducer,
    footer: footerReducer,
    career: careerReducer,
    contact: contactReducer,
    jobForm: jobFormReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});
